<template>
  <div class="d-week-selector week-selector overflow no-print text-dark">
    <ul class="week-selector__weeks" v-if="startDate">
      <li class="disabled">{{ startDateInYear }}</li>
      <li v-for="week in weeksInYear">
        <span
          :class="[{'active': week.isChosenWeek, 'isThisWeek': week.isThisWeek }]"
          v-tippy="{
        arrow: false,
                animateFill: false,
                animation : 'shift-away',
                zIndex: '999999992',
                boundary: 'window'
          }"
          :content="week.tooltipDate"
          class="pointer"
          @click="setDate(week.date)">
              {{week.weekNum}}
        </span>
      </li>
      <li class="disabled week-selector__weeks__right">{{ endDateInYear }}</li>
    </ul>
  </div>
</template>

<script>
  import moment from 'moment' // eslint-disable-line no-unused-vars

  export default {
    props: {
      date: {
        default: moment()
      },
      startDate: {
        default: null
      },
      endDate: {
        default: null
      }
    },
    computed: {
      weekDate () {
        return moment(this.date)
      },
      weeksInYear () {
        let startDate = moment(this.startDate).startOf('isoweek')
        let endDate = moment(this.endDate).endOf('isoweek')
        let weeksBetweenStartAndFinish = moment(endDate).diff(startDate, 'week')
        const self = this
        let startWeek = moment(this.startDate).isoWeek()
        let weeks = []
        for (let i = startWeek; i <= startWeek + weeksBetweenStartAndFinish; i++) {
          let date = moment(self.startDate).isoWeek(i)
          weeks.push({
            date: date,
            weekNum: date.isoWeek(),
            isChosenWeek: self.isChosenWeek(date),
            isThisWeek: self.isThisWeek(date),
            tooltipDate: self.tooltipDate(date)
          })
        }
        return weeks
      },
      startDateInYear () {
        return moment(this.startDate).format('YYYY')
      },
      endDateInYear () {
        return moment(this.endDate).format('YYYY')
      }
    },
    methods: {
      tooltipDate (date) {
        let start = moment(date).startOf('isoweek')
        let start2 = moment(date).startOf('isoweek').format('DD. MMM')
        let startFormat = start.format('DD')
        let end = moment(date).endOf('isoweek')
        let endFormat = moment(date).endOf('isoweek').format('DD. MMM YYYY')
        // If same month
        if (moment(start).format('MM') === moment(end).format('MM')) {
          return startFormat + ' - ' + endFormat
        } else {
          return start2 + ' - ' + endFormat
        }
      },
      setDate (date) {
        this.$emit('changed', date)
      },
      isChosenWeek (date) {
        return this.weekDate.isoWeek() === moment(date).isoWeek() && this.weekDate.format('YYYY') === moment(date).format('YYYY')
      },
      isThisWeek (date) {
        return moment(date).isoWeek() === moment().isoWeek() && moment(date).format('YYYY') === moment().format('YYYY')
      }
    }
  }
</script>

<style scoped>

  @import '../../assets/css/variables.css';

  .d-week-selector {
    display: flex;
    align-items: center;
    min-height: 37px
  }

  .week_selector ul {
    overflow: hidden;
  }
  .week-selector__weeks {
    display: flex;
    flex-wrap: nowrap; /* Prevents the items from wrapping */
    width: 100%; /* Ensures the container takes full width */
    list-style: none; /* Removes default list styling */
    padding: 0;
    margin: 0;
  }

  .week-selector__weeks > li {
    flex: 1; /* Distribute space evenly */
    display: flex; /* Enables flexbox for center alignment */
    justify-content: center; /* Horizontally center the child */
    align-items: center; /* Vertically center the child */
  }

  .week-selector ul li span {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: 0.15s;
    aspect-ratio: 1 / 1; /* Keeps width and height the same */
    height: 100%; /* Use 100% of the parent li height */
  }

  @media only screen and (max-width: 1100px) {
    .week-selector ul li span {
      font-size: 11px; /* Adjust font size as needed */
    }
  }

  @media only screen and (max-width: 885px) {
    .week-selector ul li span {
      font-size: 9px; /* Slightly smaller font for very small screens */
    }
  }


  .week-selector ul li span:hover {
    transform: scale(1.2);
    border: 1px solid var(--primary);
  }

  .isThisWeek {
    color: var(--primary);
    font-weight: bold;
  }

  .week-selector ul li span.active {
    background-color: var(--primary);
    border: none;
    color: white;
    transform: scale(1);
    transition: 0.5s;
  }

  .week-selector>ul>li.disabled {
    color: rgba(0, 0, 0, 0.435);
    background: transparent;
  }

  .week-selector__weeks__right {
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// WeekSelecter.vue?72c83a0a